



































import { Component, Prop, Vue } from "@/shared/vuepack";
import FileUpload from "vue-upload-component";

@Component({
  components: {
    FileUpload
  }
})
export default class HsabExpenseEvidenceShoebox extends Vue {
  stagedFiles = [];
  uploadErrors = [];
  internalFileCount = 0;

  @Prop({ default: "jpeg|jpg|gif|png|pdf|heif|heic" })
  extensionsAllowed: string;

  @Prop()
  fileCountLimit: number;

  @Prop({ default: 1024 * 1024 * 8 })
  maxFileSize: number;

  clearErrors () {
    this.uploadErrors = [];
  }

  get fileCount () {
    return 0;
  }

  get calculatedCount () {
    return this.fileCountLimit - this.fileCount - this.internalFileCount;
  }

  get regex () {
    return new RegExp(".(" + this.extensionsAllowed + ")", "i");
  }

  updateFiles (files) {
    const mappedFiles = files.map(f => {
      if (f && f.file) {
        return f.file;
      } else if (f.name && f.size && f.type) {
        return f;
      }
    });
    this.$emit("change", mappedFiles);
    this.stagedFiles = mappedFiles;
    this.internalFileCount = 0;
  }

  inputFilter (newFile, oldFile, prevent) {
    this.clearErrors();
    if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
      if (this.fileCountLimit && this.calculatedCount <= 0) {
        this.uploadErrors.push("Limit is " + this.fileCountLimit + " documents.");
        return prevent();
      }
      if (!this.regex.test(newFile.name)) {
        this.uploadErrors.push(
            "Files must be in one of the following formats: " + this.extensionsAllowed.split("|").join(", ") + ".");
        return prevent();
      }
      if (newFile.size > this.maxFileSize) {
        this.uploadErrors.push("File must be smaller than " + this.maxFileSize / 1048576 + " MB.");
        return prevent();
      }
      if (newFile.size === 0) {
        this.uploadErrors.push("File must be greater than 0 MB.");
        return prevent();
      }
      this.internalFileCount += 1;
    }
  }
}

